import { SimpleCard } from '../../../Components/Card';
import { HeadingDesc, SectionHeadingSmall } from '../../../Components/Headings';
import docImg from '../../../assets/images/png/article2.png';
import { SimpleTag } from '../../../Components/tags';
import './review.css';

function Review() {
  return (
    <div className="reviewContainer">
      <SimpleCard>
        <div className="imgBox">
          <img src={docImg} alt="docImg" />
        </div>
        <div className="docInfo">
          <div>
            <SectionHeadingSmall text="Dr. Madeeha Asad" />
            <HeadingDesc text="Tomorrow, Apr 7 - 9:45 am" />
            <div className="available">
              <HeadingDesc text="Video Consultation" />
            </div>
          </div>
          <div className="price">
            <SimpleTag text="Rs. 500" />
          </div>
        </div>
      </SimpleCard>
    </div>
  );
}
export default Review;
